"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAssets = void 0;
function loadAssets({ width, height, productMasks, scale }, assetCache) {
    const maskWidth = width * scale;
    const maskHeight = height * scale;
    const loadPromises = [
        'multiplyImageUrl',
        'clipImageUrl',
        'overImageUrl'
    ].reduce((loadPromises, mask) => {
        const maskUrl = productMasks[mask];
        if (!maskUrl || assetCache.hasImage(maskUrl, { width: maskWidth, height: maskHeight })) {
            return loadPromises;
        }
        return [
            ...loadPromises,
            assetCache.loadImage(maskUrl, { width: maskWidth, height: maskHeight }),
        ];
    }, []);
    return {
        loaded: loadPromises.length === 0,
        loadPromise: Promise.all(loadPromises),
    };
}
exports.loadAssets = loadAssets;
